export const byteFormat = (
  bytes: number,
  large: boolean,
  zeroLabel?: string
): string => {
  const sizes = large
    ? ["Bytes", "KB", "MB", "GB", "TB"]
    : ["bytes", "kb", "mb", "gb", "tb"];
  if (bytes === 0) {
    return "0 " + (zeroLabel || sizes[0]);
  }
  const ubytes: number = Math.abs(bytes);
  const i = parseInt(Math.floor(Math.log(ubytes) / Math.log(1024)).toString());
  const dec = (ubytes / Math.pow(1024, i)).toFixed(1).replace(".0", "");
  return dec + " " + sizes[i];
};

export const moneyFormat = (money: number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  return formatter.format(money as number);
};
